import { RootState } from "@/reducers";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { formatMoney } from "@/shared/utils/ultils";
import axios from "@/shared/config/axios-interceptor";
import { useEffect, useState } from "react";

const HoSoLoiNhuan = () => {
  const { user } = useSelector((state: RootState) => state.authentication);
  const [baoCao, setBaoCao] = useState<any>(null);
  const getBaoCao = async () => {
    try {
      const res = await axios.get("/transaction/bao-cao");
      console.log(res?.data);
      setBaoCao(res?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getBaoCao();
  }, []);
  return (
    <div className="wrapper">
      <div className="container-web hosoloinhuan bgnew">
        <Header title="Hồ sơ lợi nhuận" />

        <main className="px-3">
          <div className="item mb-3">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap">
              <span>Ngày đăng ký tài khoản</span>
              <span>{dayjs(user?.createdDate).format("DD/MM/YYYY")}</span>
            </div>
            <div className="card-body">
              <span className="d-block mb-2">
                {user?.fullName} {user?.username}
              </span>
              <span className="d-block mb-2">ID: {user?.id}</span>
              <span className="d-block mb-2">
                Số dư: {formatMoney(user?.money ?? 0)} VND
              </span>
              <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                <strong style={{ color: "rgb(25 135 84)" }}>
                  Tổng lợi nhuận:
                </strong>
                <span>{formatMoney(baoCao?.tongLoiNhuan ?? 0)} VNĐ</span>
              </div>
              <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                <strong style={{ color: "rgb(220 53 69)" }}>
                  Tổng tiền thưởng:
                </strong>
                <span>{formatMoney(baoCao?.tongThuong ?? 0)} VNĐ</span>
              </div>
              <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                <strong style={{ color: "rgb(255 193 7)" }}>Tổng vốn:</strong>
                <span>{formatMoney(baoCao?.guiTietKiem ?? 0)} VNĐ</span>
              </div>
            </div>
          </div>

          <div style={{ paddingBottom: 120 }}></div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default HoSoLoiNhuan;
